import { Session } from 'common/models';
import { cmsApi } from '../cmsApi';

export interface LoginRequest {
  email: string;
  password: string;
}

const authBaseUrl = '/auth';

export const withAuthEndpoints = cmsApi.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation<Session, LoginRequest>({
      query: credentials => ({
        url: `${authBaseUrl}/login`,
        method: 'POST',
        body: credentials,
      }),
    }),

    logout: builder.mutation<void, void>({
      query: () => ({
        url: `${authBaseUrl}/logout`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useLoginMutation, useLogoutMutation } = withAuthEndpoints;
